import { render, staticRenderFns } from "./Fighter.vue?vue&type=template&id=44f4431d&lang=pug&"
import script from "./Fighter.vue?vue&type=script&lang=js&"
export * from "./Fighter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports